import { KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { StyleSheet, View } from 'react-native';

const debug = require('debug')('tca:chat:components:UnsupportedMessageBubble');

export default function UnsupportedMessage(): ReactElement {
  const { t } = useTranslation(['messaging']);

  return (
    <View style={styles.messageContainer}>
      <KitText semiBold black fontSize={14} style={{ marginBottom: 2 }}>
        {t('messaging:unsupportedMessageType')}
      </KitText>
      <KitText fontSize={13} style={{ lineHeight: 15 }}>
        {t('messaging:thisMessageTypeIsNotSupportedAtThisTime')}
      </KitText>
    </View>
  );
}

const styles = StyleSheet.create({
  messageContainer: {
    borderRadius: 20,
    borderWidth: 1,
    borderColor: Colors.N100,
    paddingHorizontal: Spacing.m,
    paddingVertical: Spacing.s,
  },
  messageStyle: {
    fontStyle: 'italic',
    fontWeight: 'normal',
  },
});
